/**
 * saveQueryParams.js
 * Written by: Alex Kasemir
 */

export const SAVE_QUERY_PARAMS = `SAVE_QUERY_PARAMS`;
export const saveQueryParams = (params) => ({
  type: SAVE_QUERY_PARAMS,
  params,
});

export default saveQueryParams;
